import { Observable } from 'rxjs';
import { User } from '@auth0/auth0-spa-js'

export const USERSERVICE_INJECTION_TOKEN = 'USER_SERVICE_TOKEN';

export interface IUserService {
  authProfile$: Observable<User>;
}
